import { render, staticRenderFns } from "./ContactosCardPaciente.vue?vue&type=template&id=499e8006&scoped=true"
import script from "./ContactosCardPaciente.vue?vue&type=script&lang=js"
export * from "./ContactosCardPaciente.vue?vue&type=script&lang=js"
import style0 from "./ContactosCardPaciente.vue?vue&type=style&index=0&id=499e8006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e8006",
  null
  
)

export default component.exports